function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { $transferable } from "./symbols";

function isTransferable(thing) {
  if (!thing || _typeof(thing) !== "object") return false; // Don't check too thoroughly, since the list of transferable things in JS might grow over time

  return true;
}

export function isTransferDescriptor(thing) {
  return thing && _typeof(thing) === "object" && thing[$transferable];
}
export function Transfer(payload, transferables) {
  var _ref;

  if (!transferables) {
    if (!isTransferable(payload)) throw Error();
    transferables = [payload];
  }

  return _ref = {}, _defineProperty(_ref, $transferable, true), _defineProperty(_ref, "send", payload), _defineProperty(_ref, "transferables", transferables), _ref;
}